/**
 * <SalesViewTabs view="overview" />  - sub-navigation shared by the sales views.
 * Links: Overview (/dashboard), SKUs (/sales/skus), Brands & categories (/sales/brands), Platforms (/sales/platforms)
 * plus "Sales records". Every view link keeps the current query string so the period, comparison and
 * filters carry across views. "Sales records" opens /daily-sales for the same period and filters
 * (dailyRecordsQuery) when `scope` (useSalesScope().scope) is passed. Rendered once by SalesHubPage.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { dailyRecordsQuery } from './trend';

export const SALES_VIEWS = [
  { key: 'overview', label: 'Overview', path: '/dashboard' },
  { key: 'sku', label: 'SKUs', path: '/sales/skus' },
  { key: 'brand', label: 'Brands & categories', path: '/sales/brands' },
  { key: 'platform', label: 'Platforms', path: '/sales/platforms' },
];

export const SalesViewTabs = ({ view = 'overview', scope }) => {
  const { search } = useLocation();
  const dailyHref = scope?.date_from && scope?.date_to
    ? `/daily-sales?${dailyRecordsQuery(scope, scope.date_from, scope.date_to)}`
    : '/daily-sales';
  return (
    <nav className="sales-view-nav" aria-label="Sales views" data-testid="sales-view-tabs">
      {SALES_VIEWS.map(item => (
        <Link key={item.key} to={`${item.path}${search}`} aria-current={view === item.key ? 'page' : undefined}
          className={view === item.key ? 'active' : ''} data-testid={`sales-view-${item.key}`}>
          {item.label}
        </Link>
      ))}
      <Link className="ml-auto text-gray-500" to={dailyHref} data-testid="sales-open-records">Sales records ↗</Link>
    </nav>
  );
};

export default SalesViewTabs;
